import { useEffect, useState } from 'react'
import { getMyContactMethods, type ContactUse } from '@carouselgg/auth/contact'

/**
 * The teams the signed-in person is primary contact for, read once from
 * /auth/me — so a list of leave buttons asks one question, not one per card.
 * Empty until it loads, and if it can't: the leave still works, it just
 * doesn't carry the extra sentence.
 */
export function useMyPrimaryContactUses(enabled: boolean): ContactUse[] {
  const [uses, setUses] = useState<ContactUse[]>([])
  useEffect(() => {
    if (!enabled) return
    let live = true
    getMyContactMethods()
      .then((m) => { if (live) setUses((m.used_by ?? []).filter((u) => u.kind === 'primary')) })
      .catch(() => { if (live) setUses([]) })
    return () => { live = false }
  }, [enabled])
  return uses
}
